import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { LuSave } from "react-icons/lu";
import { GiCrossedBones } from "react-icons/gi";
import { toast } from "react-toastify";

const AddRolePrivilege = () => {
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    roleName: Yup.string().required("Role Name is required"),
    menuName: Yup.string().required("Menu Name is required"),
    view: Yup.boolean(),
    add: Yup.boolean(),
    edit: Yup.boolean(),
    delete: Yup.boolean(),
  }); 

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    try {
      // Replace with API integration
      console.log("Submitted Role Privilege:", values);
      toast.success("Role Privilege Added Successfully");
      resetForm();
      window.history.back();
    } catch (err) {
      toast.error("Failed to add role privilege");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="formContainer p-4">
      <div
        className="flex flex-col p-4 mx-5 border rounded bg-white"
        style={{ boxShadow: "0px 0px 12px #cac8c8" }}
      >
        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">
          Add Role Privilege
        </h5>

        <Formik
          initialValues={{
            roleName: "",
            menuName: "",
            view: false,
            add: false,
            edit: false,
            delete: false,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Role Name</label>
                  <Field type="text" name="roleName" className="form-control custom-shadow" />
                  <ErrorMessage name="roleName" component="div" className="text-brandRed" />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Menu Name</label>
                  <Field type="text" name="menuName" className="form-control custom-shadow" />
                  <ErrorMessage name="menuName" component="div" className="text-brandRed" />
                </div>

                {['view', 'add', 'edit', 'delete'].map((perm) => (
                  <div className="col-md-3" key={perm}>
                    <label className="form-check-label">
                      <Field type="checkbox" name={perm} className="form-check-input me-2" />
                      {perm.charAt(0).toUpperCase() + perm.slice(1)} Permission
                    </label>
                  </div>
                ))}
              </div>

              <div className="d-flex justify-content-center gap-3 mt-5">
                <button type="submit" className="saveButton d-flex" disabled={isSubmitting || loading}>
                  <span className="m-auto p-1">
                    <LuSave />
                  </span>
                  {isSubmitting || loading ? "Saving..." : "Save"}
                </button>
                <button
                  type="button"
                  className="d-flex backButton"
                  onClick={() => window.history.back()}
                >
                  <span className="m-auto p-1">
                    <GiCrossedBones />
                  </span>
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddRolePrivilege;